<template>
    <div>
        <div class="page-btns-box">
            <el-button type="text" icon="el-icon-refresh" @click="getDataList">刷新列表</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="name" label="任务名称" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column type="downloadUrl" label="下载地址" show-overflow-tooltip></el-table-column> -->
                <el-table-column prop="createTime" label="创建时间" min-width="160"></el-table-column>
                <el-table-column prop="type" label="任务类型"></el-table-column>
                <el-table-column prop="status" label="任务状态">
                    <template slot-scope="scope">
                        {{ status.get(scope.row.status) }}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="reconciliationStatus" label="对账状态">
                    <template slot-scope="scope">
                        {{ reconciliationStatus.get(scope.row.reconciliationStatus) }}
                    </template>
                </el-table-column> -->
                <el-table-column label="任务提示">
                    <template slot-scope="scope">
                        <template v-if="scope.row.reconciliationOrderNum">
                            本次导出的数据包含
                            <span class="color-danger">{{ scope.row.reconciliationOrderNum }}条</span>未收入对账或对账失败的订单
                        </template>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.reconciliationOrderNum" type="text" size="small" icon="el-icon-download"
                            @click="exportReconciliation(scope.row.id)">导出对账异常订单</el-button>
                        <el-button v-if="scope.row.downloadUrl" type="text" size="small" icon="el-icon-download"
                            @click="download(scope.row)">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { downloadFileTmp } from '@/assets/js/commonApi.js';
export default {
    data() {
        return {
            listLoading: false,
            data: null,
            dataList: null,
            params: {
                pageNo: 1,
                pageSize: this.$pageSizes[0]
            }
        }
    },
    computed: {
        status() {
            return new Map([
                [0, '待处理'],
                [1, '处理中'],
                [2, '处理成功'],
                [3, '处理失败'],
            ])
        },
        reconciliationStatus() {
            return new Map([
                [0, '对账失败'],
                [1, '对账成功'],
                [2, '未对账'],
            ])
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/download/list",
                method: "POST",
                params: this.params
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //下载
        async download(item) {
            const _url = item.downloadUrl;
            const _name = item.name;
            await downloadFileTmp(_url, _name + '.' + this.$utils.getFileType(_url));
        },

        //导出异常
        async exportReconciliation(id){
            let filePath;
            const res = await this.$request({
                url:'/finance/exportReconciliation',
                method: 'post',
                params: {jobId: id},
            })
                .catch(err => {
                    this.$message({message: err.message, type: 'error'});
                })
            const{state,msg,result} = res.data;
            if(state == 1 && result){
                filePath = result.url;
            }else{
                return this.$message.error(msg || '下载失败');
            }   

            await downloadFileTmp(filePath,'异常订单.'+this.$utils.getFileType(filePath));
        }
    }
}
</script>